/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { CalendarBookingViewQuestionAnswersBookingFragmentDoc } from '../SettingsPageCalendarView/questions/CalendarBookingViewQuestionAnswers/CalendarBookingViewQuestionAnswers.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type BookingCancelReason =
  | 'ENTRANCE_CANCELLED'
  | 'USER_CANCELLED';

export type Channel =
  /** 中国銀行 */
  | 'CHUGOKU_GINKO'
  /** ファミペイ */
  | 'FAMIPAY'
  /** 400F */
  | 'FOUR_HUNDRED_F'
  /** 400F 保険比較 */
  | 'FOUR_HUNDRED_F_INSURANCE_COMPARISON'
  /** はなさく生命 */
  | 'HANASAKU'
  /** ほけんの窓口 */
  | 'HOKEN_NO_MADOGUCHI'
  /** JCB */
  | 'JCB'
  /** ゆうちょ銀行 */
  | 'JP_BANK'
  /** きらぼし銀行 */
  | 'KIRABOSHI'
  /** ライフプラザパートナーズ */
  | 'LIFE_PLAZA'
  /** メットライフ生命 */
  | 'MET_LIFE'
  /** みんかぶ */
  | 'MINKABU'
  /** マネーフォワード */
  | 'MONEY_FORWARD'
  /** ninpath */
  | 'NINPATH'
  /** ニッセイアセットマネジメント */
  | 'NISSEI_AM'
  /** オカネコ */
  | 'OKANEKO'
  /** オカネコ転職 */
  | 'OKANEKO_TENSHOKU'
  /** OKB */
  | 'OKB'
  /** オリックス銀行 */
  | 'ORIX_BANK'
  /** Ponta */
  | 'PONTA'
  /** 楽天証券 */
  | 'RAKUTEN'
  /** 楽天証券インハウスアドバイザー */
  | 'RAKUTEN_IN_HOUSE_ADVISOR'
  /** 楽天証券の運用相談 */
  | 'RAKUTEN_UNYOU_SOUDAN'
  /** SBI証券 */
  | 'SBI'
  /** SBIマネープラザ */
  | 'SBI_MONEY_PLAZA'
  /** SBI証券の運用相談 */
  | 'SBI_UNYOU_SOUDAN'
  /** 三井住友カード */
  | 'SMCC'
  /** トヨタカローラ */
  | 'TOYOTA_COROLLA'
  /** Vitalityスマート */
  | 'VITALITY_SMART'
  /** Yahoo! JAPAN */
  | 'YAHOO'
  /** 財形住宅金融 */
  | 'ZAIKEI_JUTAKU_KINYU';

export type FetchBookingQueryVariables = Exact<{
  guid: string | number;
}>;


export type FetchBookingQuery = { bookingV2:
    | { __typename: 'Booking', guid: string, userGUID: string, startsAt: TimeString, endsAt: TimeString, summary: string | null, description: string | null, cancelReason: Types.BookingCancelReason | null, meetingURL: string | null, isBookedByV2User: boolean, createdAt: TimeString, okanekoUser: { id: string, nickname: string, channel: Types.Channel, karteV2:
          | { __typename: 'Karte', id: string }
          | { __typename: 'UserKarteErrorPermissionDenied', message: string }
         | null, chatRoom: { id: string } | null } | null, assignedStaff: { guid: string, displayName: string }, questionAnswers: Array<{ questionText: string, answer: string }> }
    | { __typename: 'BookingErrorNotFound', message: string }
    | { __typename: 'BookingErrorPermissionDenined', message: string }
   };


export const FetchBookingDocument = gql`
    query FetchBooking($guid: ID!) {
  bookingV2(guid: $guid) {
    __typename
    ... on Booking {
      guid
      userGUID
      startsAt
      endsAt
      summary
      description
      cancelReason
      meetingURL
      isBookedByV2User
      okanekoUser {
        id
        nickname
        channel
        karteV2 {
          __typename
          ... on Karte {
            id
          }
          ... on UserKarteErrorPermissionDenied {
            message
          }
        }
        chatRoom {
          id
        }
      }
      assignedStaff {
        guid
        displayName
      }
      createdAt
      ...CalendarBookingViewQuestionAnswersBooking
    }
    ... on BookingErrorNotFound {
      message
    }
    ... on BookingErrorPermissionDenined {
      message
    }
  }
}
    ${CalendarBookingViewQuestionAnswersBookingFragmentDoc}`;

/**
 * __useFetchBookingQuery__
 *
 * To run a query within a Vue component, call `useFetchBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchBookingQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchBookingQuery({
 *   guid: // value for 'guid'
 * });
 */
export function useFetchBookingQuery(variables: FetchBookingQueryVariables | VueCompositionApi.Ref<FetchBookingQueryVariables> | ReactiveFunction<FetchBookingQueryVariables>, options: VueApolloComposable.UseQueryOptions<FetchBookingQuery, FetchBookingQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchBookingQuery, FetchBookingQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchBookingQuery, FetchBookingQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FetchBookingQuery, FetchBookingQueryVariables>(FetchBookingDocument, variables, options);
}
export function useFetchBookingLazyQuery(variables?: FetchBookingQueryVariables | VueCompositionApi.Ref<FetchBookingQueryVariables> | ReactiveFunction<FetchBookingQueryVariables>, options: VueApolloComposable.UseQueryOptions<FetchBookingQuery, FetchBookingQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchBookingQuery, FetchBookingQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchBookingQuery, FetchBookingQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FetchBookingQuery, FetchBookingQueryVariables>(FetchBookingDocument, variables, options);
}
export type FetchBookingQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FetchBookingQuery, FetchBookingQueryVariables>;